import { render, staticRenderFns } from "./LanguageDropdownInput.vue?vue&type=template&id=288b5368&scoped=true"
import script from "./LanguageDropdownInput.vue?vue&type=script&lang=js"
export * from "./LanguageDropdownInput.vue?vue&type=script&lang=js"
import style0 from "./LanguageDropdownInput.vue?vue&type=style&index=0&id=288b5368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b5368",
  null
  
)

export default component.exports